import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import { displayDate } from '../../utils/date';

interface InjectedProps {
  scheduleStore: any;
  newAuthStore: any;
}

interface TimeProps extends Partial<InjectedProps> {
  format?: string;
}

interface TimeState {
  time: Date;
}

class Time extends Component<TimeProps, TimeState> {
  constructor(props: TimeProps) {
    super(props);
    this.state = {
      time: new Date(),
    };
  }
  intervalId: number | null = null;

  componentDidMount() {
    this.intervalId = window.setInterval(() => {
      this.setState({ time: new Date() });
    }, 1000);
  }

  componentWillUnmount() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
    }
  }

  render() {
    const {
      format = 'L LT',
      scheduleStore,
      newAuthStore,
    } = this.props as TimeProps & InjectedProps;
    const { timezone } = scheduleStore;
    const { user } = newAuthStore;

    return (
      <span className="timer-app" title={timezone}>
        {displayDate(this.state.time, timezone, format, user.language)}
      </span>
    );
  }
}

export default inject('scheduleStore', 'newAuthStore')(observer(Time));

